<div class="dasboard-width">
  <div class="row header mar-lft-rgt-0">
    <div class="col-md-6">Report Dashboard - Trend</div>
  </div>
  <div class="content mr-top-5 mar-lft-rgt-0">
    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
    <div class="row content mr-top-5 mar-lft-rgt-0">
      <div class="col-md-3">
          <div class="form-group">
              <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedReportType"
                      (change)="onReportTypeChange($event.target.selectedIndex)">
                <option *ngFor="let reportType of reportTypeArray" [value]="reportType.type">{{reportType.view}}</option>
              </select>
          </div>
      </div>
      <div *ngIf="viewTicketType" class="col-md-3">
          <div class="form-group">
              <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedTicketType"
                      (change)="onTicketTypeChange($event.target.selectedIndex)">
                <option *ngFor="let ticketType of ticketTypeArray" [value]="ticketType.id">{{ticketType.name}}</option>
              </select>
          </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedReportStatus"
                    (change)="onReportStatusChange($event.target.selectedIndex)">
              <option *ngFor="let reportStatus of reportStatusArray" [value]="reportStatus.type">{{reportStatus.view}}</option>
            </select>
        </div>
      </div>
      <div class="col-md-3">
          <div class="form-group">
              <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedReportFilter"
                      (change)="onReportFilterChange($event.target.selectedIndex)">
                <option *ngFor="let reportFilter of reportFilterArray" [value]="reportFilter.type">{{reportFilter.view}}</option>
              </select>
          </div>
      </div>
      <div *ngIf="dateRangeView" class="col-md-4">
          <div class="row mar-lft-rgt-0">
              <div class="form-group col-sm-4">
                  <input [owlDateTimeTrigger]="dt9" [owlDateTime]="dt9" class="form-control radius-0 font-13"
                          [(ngModel)]="fromDate" placeholder='From Date'>
                  <owl-date-time [pickerType]="'calendar'" #dt9></owl-date-time>
              </div>
              <div class="form-group col-sm-4">
                  <input [owlDateTimeTrigger]="dt10" [owlDateTime]="dt10" class="form-control radius-0 font-13"
                          [(ngModel)]="toDate" placeholder='To Date'>
                  <owl-date-time [pickerType]="'calendar'" #dt10></owl-date-time>
              </div>
              <div class="form-group col-sm-4">
                <div class="form-group">
                    <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedReportScale"
                            (change)="onReportScaleChange($event.target.selectedIndex)">
                      <option *ngFor="let reportScale of reportScaleArray" [value]="reportScale.type">{{reportScale.view}}</option>
                    </select>
                </div>
              </div>
          </div>
      </div>
      <div *ngIf="tillDateView" class="col-md-4">
          <div class="form-group">
              <input [owlDateTimeTrigger]="dt10" [owlDateTime]="dt10" class="form-control radius-0 font-13"
                          [(ngModel)]="tillDate" placeholder='To Date'>
              <owl-date-time [pickerType]="'calendar'" #dt10></owl-date-time>
          </div>
      </div>
      <div class="col-md-2">
          <button  type="button" class="btn btn-success radius-0" (click)="generateDashboardReport()">Submit</button>
      </div>
    </div>
    <div [hidden]="!viewReport" class="row mar-lft-rgt-0">
        <div class="col-12">
                <button  type="button" class="btn btn-success font-13 radius-0 float-right" (click)="exportAsPDF()">Export to PDF</button>
        </div>
    </div>
    
    <div class="row content mr-top-5 mar-lft-rgt-0" #reportBody (window:resize)="onResize($event)">
      <div class="col-lg-12" style="padding: 1%">
        <div [hidden]="!viewReport" style="text-align: center; border: 1px solid; min-width: 500px;">
            <div style="text-align: center;">{{reportStatusTitle}} - {{reportFilterTitle}} Trend</div>
            <div #trendChart id="bar-chart-volume"></div>
        </div>
      </div>
    </div>
    
  </div>
</div>
